import React from 'react';
import Row from 'react-bootstrap/Row';
import { Col } from 'react-bootstrap';

export function UnitCostAnswers(props) {
    const data = props.data;
    const spend = props.spend;

    const AUdollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'AUD',
    });

    const [scenarios, setScenarios] = React.useState([]);
    const scenariosToGenerate = 3; // Number of scenarios to generate

    const handleGenerateScenarios = () => {
        const newScenarios = [];
        for (let i = 0; i < scenariosToGenerate; i++) {
            newScenarios.push(scenarioMarker());
        }
        setScenarios(newScenarios);
    };

    React.useEffect(() => {
        handleGenerateScenarios();
    }, [spend, data, scenariosToGenerate]);

    function scenarioMarker() {
        var result = [];
        var remainingSpend = spend;
        for (var i = 0; i < data.length; i++) {
            var item = data[i];

            var itemCostsCount = item.costs.length;
            var randomIndex = Math.floor(Math.random() * itemCostsCount);

            var itemCost = item.costs[randomIndex].cost;
            var itemCostType = item.costs[randomIndex].costType;

            if (remainingSpend >= itemCost) {
                var maxQuantity = Math.floor(remainingSpend / itemCost);
                // Random quantity between 1 and maxQuantity / 2 so we don't always spend all the money on one item
                var quantity = Math.floor(Math.random() * maxQuantity / 2) + 1;
                // Total cost for the selected quantity
                itemCost *= quantity;
                result.push(`${item.emoji} - ${quantity} ${itemCostType} ${item.nounForEach} ${item.name} for ${AUdollar.format(itemCost)}`);
                remainingSpend -= itemCost;
            }
        }

        if (remainingSpend > 0) {
            result.push(`Remaining to spend elsewhere: ${AUdollar.format(remainingSpend)}`);
        }
        return result;
    }

    return (
        <>
            <Row className='unit-cost-answers'>
                {scenarios.map((scenario, index) => (
                    <Col key={index}>
                        <div className='unit-cost-answers-header'>
                            <h3>Scenario {index + 1}</h3>
                            <table className='styled-table'>
                                {scenario.map((item, itemIndex) => (
                                    <tr key={itemIndex}>
                                        <td>{item}</td>
                                    </tr>
                                ))}
                            </table>
                        </div>
                    </Col>
                ))}

            </Row>
            <Row>
                <Col>
                    <button className='btn btn-primary' onClick={handleGenerateScenarios}>Generate New Scenarios</button>
                </Col>
            </Row>
        </>
    );
}
